import {
  getPage,
  modifyObj,
  getAll,
  getDetail,
  deleteObj,
  addObj,
  getTeamReport,
  changePicture,
  getMyUserGroupAll,
  getMyUserGroupPage,
  analyzeVehicleLicensePicture,
  changeBusinessUser,
  bindPositioningDeviceInfos,
  unBindPositioningDeviceInfos,
  batchAddObj,
  cancel,
  uploadAddFile,
  confirmUpload,
  confirmRecept,
  omTest,
  callBack,
  batchCallBack,
  reschedule,
  distribution,
  importOrders,
  audit,
  getReport,
  batchAudit,
  generateInsuranceVideoCommitment,
  changeInstaller,
  getMyBusinessPage,
  getMyNotInstallNum,
  getMyGroupNotInstallNum,
  confirmInstalled,
  getMyInstallPage,
  batchConfirmRecept,
  forceConfirmInstalled,
  getTeamOperatorReport,
  uploadInstallorderePicture,
  removeInstallorderePicture,
  modifyInstallOrderBase,
  batchDistribution,
  generateMaterial,
  addToInstallRemark
} from '@/api/installorderserv'

export default {
  state: {
    state_InstallOrder_GetPageResult: null,
    state_InstallOrder_ModifyObjResult: null,
    state_InstallOrder_GetAllResult: null,
    state_InstallOrder_GetDetailResult: null,
    state_InstallOrder_DeleteObjResult: null,
    state_InstallOrder_AddObjResult: null,
    state_InstallOrder_GetTeamReportResult: null,
    state_InstallOrder_ChangePictureResult: null,
    state_InstallOrder_GetMyUserGroupAllResult: null,
    state_InstallOrder_GetMyUserGroupPageResult: null,
    state_InstallOrder_AnalyzeVehicleLicensePictureResult: null,
    state_InstallOrder_ChangeBusinessUserResult: null,
    state_InstallOrder_BindPositioningDeviceInfosResult: null,
    state_InstallOrder_UnBindPositioningDeviceInfosResult: null,
    state_InstallOrder_BatchAddObjResult: null,
    state_InstallOrder_CancelResult: null,
    state_InstallOrder_UploadAddFileResult: null,
    state_InstallOrder_ConfirmUploadResult: null,
    state_InstallOrder_ConfirmReceptResult: null,
    state_InstallOrder_OmTestResult: null,
    state_InstallOrder_CallBackResult: null,
    state_InstallOrder_BatchCallBackResult: null,
    state_InstallOrder_RescheduleResult: null,
    state_InstallOrder_DistributionResult: null,
    state_InstallOrder_ImportOrdersResult: null,
    state_InstallOrder_AuditResult: null,
    state_InstallOrder_GetReportResult: null,
    state_InstallOrder_BatchAuditResult: null,
    state_InstallOrder_GenerateInsuranceVideoCommitmentResult: null,
    state_InstallOrder_ChangeInstallerResult: null,
    state_InstallOrder_GetMyBusinessPageResult: null,
    state_InstallOrder_GetMyNotInstallNumResult: null,
    state_InstallOrder_GetMyGroupNotInstallNumResult: null,
    state_InstallOrder_ConfirmInstalledResult: null,
    state_InstallOrder_GetMyInstallPageResult: null,
    state_InstallOrder_BatchConfirmReceptResult: null,
    state_InstallOrder_ForceConfirmInstalledResult: null,
    state_InstallOrder_GetTeamOperatorReportResult: null,
    state_InstallOrder_UploadInstallorderePictureResult: null,
    state_InstallOrder_RemoveInstallorderePictureResult: null,
    state_InstallOrder_ModifyInstallOrderBaseResult: null,
    state_InstallOrder_BatchDistributionResult: null,
    state_InstallOrder_GenerateMaterialResult: null,
    state_InstallOrder_AddToInstallRemarkResult: null
  },
  mutations: {
    SET_INSTALLORDER_GETPAGE_RESULT: (state, rst) => {
      state.state_InstallOrder_GetPageResult = rst
    },
    SET_INSTALLORDER_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_InstallOrder_ModifyObjResult = rst
    },
    SET_INSTALLORDER_GETALL_RESULT: (state, rst) => {
      state.state_InstallOrder_GetAllResult = rst
    },
    SET_INSTALLORDER_GETDETAIL_RESULT: (state, rst) => {
      state.state_InstallOrder_GetDetailResult = rst
    },
    SET_INSTALLORDER_DELETEOBJ_RESULT: (state, rst) => {
      state.state_InstallOrder_DeleteObjResult = rst
    },
    SET_INSTALLORDER_ADDOBJ_RESULT: (state, rst) => {
      state.state_InstallOrder_AddObjResult = rst
    },
    SET_INSTALLORDER_GETTEAMREPORT_RESULT: (state, rst) => {
      state.state_InstallOrder_GetTeamReportResult = rst
    },
    SET_INSTALLORDER_CHANGEPICTURE_RESULT: (state, rst) => {
      state.state_InstallOrder_ChangePictureResult = rst
    },
    SET_INSTALLORDER_GETMYUSERGROUPALL_RESULT: (state, rst) => {
      state.state_InstallOrder_GetMyUserGroupAllResult = rst
    },
    SET_INSTALLORDER_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_InstallOrder_GetMyUserGroupPageResult = rst
    },
    SET_INSTALLORDER_ANALYZEVEHICLELICENSEPICTURE_RESULT: (state, rst) => {
      state.state_InstallOrder_AnalyzeVehicleLicensePictureResult = rst
    },
    SET_INSTALLORDER_CHANGEBUSINESSUSER_RESULT: (state, rst) => {
      state.state_InstallOrder_ChangeBusinessUserResult = rst
    },
    SET_INSTALLORDER_BINDPOSITIONINGDEVICEINFOS_RESULT: (state, rst) => {
      state.state_InstallOrder_BindPositioningDeviceInfosResult = rst
    },
    SET_INSTALLORDER_UNBINDPOSITIONINGDEVICEINFOS_RESULT: (state, rst) => {
      state.state_InstallOrder_UnBindPositioningDeviceInfosResult = rst
    },
    SET_INSTALLORDER_BATCHADDOBJ_RESULT: (state, rst) => {
      state.state_InstallOrder_BatchAddObjResult = rst
    },
    SET_INSTALLORDER_CANCEL_RESULT: (state, rst) => {
      state.state_InstallOrder_CancelResult = rst
    },
    SET_INSTALLORDER_UPLOADADDFILE_RESULT: (state, rst) => {
      state.state_InstallOrder_UploadAddFileResult = rst
    },
    SET_INSTALLORDER_CONFIRMUPLOAD_RESULT: (state, rst) => {
      state.state_InstallOrder_ConfirmUploadResult = rst
    },
    SET_INSTALLORDER_CONFIRMRECEPT_RESULT: (state, rst) => {
      state.state_InstallOrder_ConfirmReceptResult = rst
    },
    SET_INSTALLORDER_OMTEST_RESULT: (state, rst) => {
      state.state_InstallOrder_OmTestResult = rst
    },
    SET_INSTALLORDER_CALLBACK_RESULT: (state, rst) => {
      state.state_InstallOrder_CallBackResult = rst
    },
    SET_INSTALLORDER_BATCHCALLBACK_RESULT: (state, rst) => {
      state.state_InstallOrder_BatchCallBackResult = rst
    },
    SET_INSTALLORDER_RESCHEDULE_RESULT: (state, rst) => {
      state.state_InstallOrder_RescheduleResult = rst
    },
    SET_INSTALLORDER_DISTRIBUTION_RESULT: (state, rst) => {
      state.state_InstallOrder_DistributionResult = rst
    },
    SET_INSTALLORDER_IMPORTORDERS_RESULT: (state, rst) => {
      state.state_InstallOrder_ImportOrdersResult = rst
    },
    SET_INSTALLORDER_AUDIT_RESULT: (state, rst) => {
      state.state_InstallOrder_AuditResult = rst
    },
    SET_INSTALLORDER_GETREPORT_RESULT: (state, rst) => {
      state.state_InstallOrder_GetReportResult = rst
    },
    SET_INSTALLORDER_BATCHAUDIT_RESULT: (state, rst) => {
      state.state_InstallOrder_BatchAuditResult = rst
    },
    SET_INSTALLORDER_GENERATEINSURANCEVIDEOCOMMITMENT_RESULT: (state, rst) => {
      state.state_InstallOrder_GenerateInsuranceVideoCommitmentResult = rst
    },
    SET_INSTALLORDER_CHANGEINSTALLER_RESULT: (state, rst) => {
      state.state_InstallOrder_ChangeInstallerResult = rst
    },
    SET_INSTALLORDER_GETMYBUSINESSPAGE_RESULT: (state, rst) => {
      state.state_InstallOrder_GetMyBusinessPageResult = rst
    },
    SET_INSTALLORDER_GETMYNOTINSTALLNUM_RESULT: (state, rst) => {
      state.state_InstallOrder_GetMyNotInstallNumResult = rst
    },
    SET_INSTALLORDER_GETMYGROUPNOTINSTALLNUM_RESULT: (state, rst) => {
      state.state_InstallOrder_GetMyGroupNotInstallNumResult = rst
    },
    SET_INSTALLORDER_CONFIRMINSTALLED_RESULT: (state, rst) => {
      state.state_InstallOrder_ConfirmInstalledResult = rst
    },
    SET_INSTALLORDER_GETMYINSTALLPAGE_RESULT: (state, rst) => {
      state.state_InstallOrder_GetMyInstallPageResult = rst
    },
    SET_INSTALLORDER_BATCHCONFIRMRECEPT_RESULT: (state, rst) => {
      state.state_InstallOrder_BatchConfirmReceptResult = rst
    },
    SET_INSTALLORDER_FORCECONFIRMINSTALLED_RESULT: (state, rst) => {
      state.state_InstallOrder_ForceConfirmInstalledResult = rst
    },
    SET_INSTALLORDER_GETTEAMOPERATORREPORT_RESULT: (state, rst) => {
      state.state_InstallOrder_GetTeamOperatorReportResult = rst
    },
    SET_INSTALLORDER_UPLOADINSTALLORDEREPICTURE_RESULT: (state, rst) => {
      state.state_InstallOrder_UploadInstallorderePictureResult = rst
    },
    SET_INSTALLORDER_REMOVEINSTALLORDEREPICTURE_RESULT: (state, rst) => {
      state.state_InstallOrder_RemoveInstallorderePictureResult = rst
    },
    SET_INSTALLORDER_MODIFYINSTALLORDERBASE_RESULT: (state, rst) => {
      state.state_InstallOrder_ModifyInstallOrderBaseResult = rst
    },
    SET_INSTALLORDER_BATCHDISTRIBUTION_RESULT: (state, rst) => {
      state.state_InstallOrder_BatchDistributionResult = rst
    },
    SET_INSTALLORDER_GENERATEMATERIAL_RESULT: (state, rst) => {
      state.state_InstallOrder_GenerateMaterialResult = rst
    },
    SET_INSTALLORDER_ADDTOINSTALLREMARK_RESULT: (state, rst) => {
      state.state_InstallOrder_AddToInstallRemarkResult = rst
    }
  },
  actions: {
    InstallOrderServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetTeamReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getTeamReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETTEAMREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETTEAMREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_ChangePicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        changePicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_CHANGEPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_CHANGEPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetMyUserGroupAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETMYUSERGROUPALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETMYUSERGROUPALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetMyUserGroupPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETMYUSERGROUPPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETMYUSERGROUPPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_AnalyzeVehicleLicensePicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        analyzeVehicleLicensePicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_ANALYZEVEHICLELICENSEPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_ANALYZEVEHICLELICENSEPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_ChangeBusinessUser ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        changeBusinessUser(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_CHANGEBUSINESSUSER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_CHANGEBUSINESSUSER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_BindPositioningDeviceInfos ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        bindPositioningDeviceInfos(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_BINDPOSITIONINGDEVICEINFOS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_BINDPOSITIONINGDEVICEINFOS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_UnBindPositioningDeviceInfos ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        unBindPositioningDeviceInfos(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_UNBINDPOSITIONINGDEVICEINFOS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_UNBINDPOSITIONINGDEVICEINFOS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_BatchAddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchAddObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_BATCHADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_BATCHADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_Cancel ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        cancel(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_CANCEL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_CANCEL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_UploadAddFile ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        uploadAddFile(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_UPLOADADDFILE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_UPLOADADDFILE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_ConfirmUpload ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmUpload(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_CONFIRMUPLOAD_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_CONFIRMUPLOAD_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_ConfirmRecept ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmRecept(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_CONFIRMRECEPT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_CONFIRMRECEPT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_OmTest ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        omTest(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_OMTEST_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_OMTEST_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_CallBack ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        callBack(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_CALLBACK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_CALLBACK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_BatchCallBack ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchCallBack(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_BATCHCALLBACK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_BATCHCALLBACK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_Reschedule ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        reschedule(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_RESCHEDULE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_RESCHEDULE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_Distribution ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        distribution(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_DISTRIBUTION_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_DISTRIBUTION_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_ImportOrders ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        importOrders(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_IMPORTORDERS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_IMPORTORDERS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_Audit ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        audit(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_AUDIT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_AUDIT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_BatchAudit ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchAudit(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_BATCHAUDIT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_BATCHAUDIT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GenerateInsuranceVideoCommitment ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        generateInsuranceVideoCommitment(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GENERATEINSURANCEVIDEOCOMMITMENT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GENERATEINSURANCEVIDEOCOMMITMENT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_ChangeInstaller ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        changeInstaller(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_CHANGEINSTALLER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_CHANGEINSTALLER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetMyBusinessPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyBusinessPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETMYBUSINESSPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETMYBUSINESSPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetMyNotInstallNum ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyNotInstallNum(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETMYNOTINSTALLNUM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETMYNOTINSTALLNUM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetMyGroupNotInstallNum ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyGroupNotInstallNum(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETMYGROUPNOTINSTALLNUM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETMYGROUPNOTINSTALLNUM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_ConfirmInstalled ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmInstalled(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_CONFIRMINSTALLED_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_CONFIRMINSTALLED_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetMyInstallPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyInstallPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETMYINSTALLPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETMYINSTALLPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_BatchConfirmRecept ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchConfirmRecept(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_BATCHCONFIRMRECEPT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_BATCHCONFIRMRECEPT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_ForceConfirmInstalled ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        forceConfirmInstalled(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_FORCECONFIRMINSTALLED_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_FORCECONFIRMINSTALLED_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GetTeamOperatorReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getTeamOperatorReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GETTEAMOPERATORREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GETTEAMOPERATORREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_UploadInstallorderePicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        uploadInstallorderePicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_UPLOADINSTALLORDEREPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_UPLOADINSTALLORDEREPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_RemoveInstallorderePicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        removeInstallorderePicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_REMOVEINSTALLORDEREPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_REMOVEINSTALLORDEREPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_ModifyInstallOrderBase ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyInstallOrderBase(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_MODIFYINSTALLORDERBASE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_MODIFYINSTALLORDERBASE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_BatchDistribution ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchDistribution(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_BATCHDISTRIBUTION_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_BATCHDISTRIBUTION_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_GenerateMaterial ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        generateMaterial(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_GENERATEMATERIAL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_GENERATEMATERIAL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InstallOrderServ_AddToInstallRemark ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addToInstallRemark(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSTALLORDER_ADDTOINSTALLREMARK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSTALLORDER_ADDTOINSTALLREMARK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_InstallOrder_GetPageResult: state => {
      return state.state_InstallOrder_GetPageResult
    },
    get_InstallOrder_ModifyObjResult: state => {
      return state.state_InstallOrder_ModifyObjResult
    },
    get_InstallOrder_GetAllResult: state => {
      return state.state_InstallOrder_GetAllResult
    },
    get_InstallOrder_GetDetailResult: state => {
      return state.state_InstallOrder_GetDetailResult
    },
    get_InstallOrder_DeleteObjResult: state => {
      return state.state_InstallOrder_DeleteObjResult
    },
    get_InstallOrder_AddObjResult: state => {
      return state.state_InstallOrder_AddObjResult
    },
    get_InstallOrder_GetTeamReportResult: state => {
      return state.state_InstallOrder_GetTeamReportResult
    },
    get_InstallOrder_ChangePictureResult: state => {
      return state.state_InstallOrder_ChangePictureResult
    },
    get_InstallOrder_GetMyUserGroupAllResult: state => {
      return state.state_InstallOrder_GetMyUserGroupAllResult
    },
    get_InstallOrder_GetMyUserGroupPageResult: state => {
      return state.state_InstallOrder_GetMyUserGroupPageResult
    },
    get_InstallOrder_AnalyzeVehicleLicensePictureResult: state => {
      return state.state_InstallOrder_AnalyzeVehicleLicensePictureResult
    },
    get_InstallOrder_ChangeBusinessUserResult: state => {
      return state.state_InstallOrder_ChangeBusinessUserResult
    },
    get_InstallOrder_BindPositioningDeviceInfosResult: state => {
      return state.state_InstallOrder_BindPositioningDeviceInfosResult
    },
    get_InstallOrder_UnBindPositioningDeviceInfosResult: state => {
      return state.state_InstallOrder_UnBindPositioningDeviceInfosResult
    },
    get_InstallOrder_BatchAddObjResult: state => {
      return state.state_InstallOrder_BatchAddObjResult
    },
    get_InstallOrder_CancelResult: state => {
      return state.state_InstallOrder_CancelResult
    },
    get_InstallOrder_UploadAddFileResult: state => {
      return state.state_InstallOrder_UploadAddFileResult
    },
    get_InstallOrder_ConfirmUploadResult: state => {
      return state.state_InstallOrder_ConfirmUploadResult
    },
    get_InstallOrder_ConfirmReceptResult: state => {
      return state.state_InstallOrder_ConfirmReceptResult
    },
    get_InstallOrder_OmTestResult: state => {
      return state.state_InstallOrder_OmTestResult
    },
    get_InstallOrder_CallBackResult: state => {
      return state.state_InstallOrder_CallBackResult
    },
    get_InstallOrder_BatchCallBackResult: state => {
      return state.state_InstallOrder_BatchCallBackResult
    },
    get_InstallOrder_RescheduleResult: state => {
      return state.state_InstallOrder_RescheduleResult
    },
    get_InstallOrder_DistributionResult: state => {
      return state.state_InstallOrder_DistributionResult
    },
    get_InstallOrder_ImportOrdersResult: state => {
      return state.state_InstallOrder_ImportOrdersResult
    },
    get_InstallOrder_AuditResult: state => {
      return state.state_InstallOrder_AuditResult
    },
    get_InstallOrder_GetReportResult: state => {
      return state.state_InstallOrder_GetReportResult
    },
    get_InstallOrder_BatchAuditResult: state => {
      return state.state_InstallOrder_BatchAuditResult
    },
    get_InstallOrder_GenerateInsuranceVideoCommitmentResult: state => {
      return state.state_InstallOrder_GenerateInsuranceVideoCommitmentResult
    },
    get_InstallOrder_ChangeInstallerResult: state => {
      return state.state_InstallOrder_ChangeInstallerResult
    },
    get_InstallOrder_GetMyBusinessPageResult: state => {
      return state.state_InstallOrder_GetMyBusinessPageResult
    },
    get_InstallOrder_GetMyNotInstallNumResult: state => {
      return state.state_InstallOrder_GetMyNotInstallNumResult
    },
    get_InstallOrder_GetMyGroupNotInstallNumResult: state => {
      return state.state_InstallOrder_GetMyGroupNotInstallNumResult
    },
    get_InstallOrder_ConfirmInstalledResult: state => {
      return state.state_InstallOrder_ConfirmInstalledResult
    },
    get_InstallOrder_GetMyInstallPageResult: state => {
      return state.state_InstallOrder_GetMyInstallPageResult
    },
    get_InstallOrder_BatchConfirmReceptResult: state => {
      return state.state_InstallOrder_BatchConfirmReceptResult
    },
    get_InstallOrder_ForceConfirmInstalledResult: state => {
      return state.state_InstallOrder_ForceConfirmInstalledResult
    },
    get_InstallOrder_GetTeamOperatorReportResult: state => {
      return state.state_InstallOrder_GetTeamOperatorReportResult
    },
    get_InstallOrder_UploadInstallorderePictureResult: state => {
      return state.state_InstallOrder_UploadInstallorderePictureResult
    },
    get_InstallOrder_RemoveInstallorderePictureResult: state => {
      return state.state_InstallOrder_RemoveInstallorderePictureResult
    },
    get_InstallOrder_ModifyInstallOrderBaseResult: state => {
      return state.state_InstallOrder_ModifyInstallOrderBaseResult
    },
    get_InstallOrder_BatchDistributionResult: state => {
      return state.state_InstallOrder_BatchDistributionResult
    },
    get_InstallOrder_GenerateMaterialResult: state => {
      return state.state_InstallOrder_GenerateMaterialResult
    },
    get_InstallOrder_AddToInstallRemarkResult: state => {
      return state.state_InstallOrder_AddToInstallRemarkResult
    }
  }
}
